import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
    const { t } = useTranslation();

    return (
        <footer className="selezium-footer">
            {/* LEFT: Subscription (top) + Big SELEZIUM Logo (bottom) */}
            <div className="footer-left">
                <div className="footer-subscription">
                    <h3>{t('footer.stayInspired') || 'Будьте в курсі'}</h3>
                    <p className="sub-description">
                        {t('footer.stayInspiredSub') || 'Отримуйте останні новини і тренди на свою пошту'}
                    </p>

                    <label htmlFor="footer-email" className="footer-label">
                        {t('footer.emailAddress') || 'Email адреса'} <span>*</span>
                    </label>
                    <input
                        type="email"
                        id="footer-email"
                        placeholder={t('footer.emailPlaceholder') || 'footer.emailPlaceholder'}
                        className="footer-input"
                    />
                    <div className="footer-checkbox">
                        <input type="checkbox" id="subscribeCheckbox" />
                        <label htmlFor="subscribeCheckbox">
                            {t('footer.subscribeCheckbox') || 'Так, підписати мене на розсилку.'}
                        </label>
                    </div>
                    <button className="footer-submit-btn">
                        {t('footer.submitBtn') || 'Надіслати'}
                    </button>
                </div>

                <h1 className="footer-big-title">
                    {t('footer.selezium') || 'SELEZIUM'}
                </h1>
            </div>

            {/* RIGHT: Center links (top) + Contacts (bottom) */}
            <div className="footer-right">
                {/* Три колонки: Види товарів, Офіційні посилання, Соцмережі */}
                <div className="footer-center">
                    <div className="footer-links-group">
                        <Link to="/category/laptop-cases">{t('footer.laptopCases') || 'Чохли для ноутбуків'}</Link>
                        <Link to="/category/iphone-cases">{t('footer.mobileCases') || 'Чохли для телефонів'}</Link>
                        <Link to="/category/wallets">{t('footer.wallets') || 'Гаманці'}</Link>
                        <Link to="/care">{t('header.leatherCare') || 'Догляд за шкірою'}</Link>
                        <Link to="/about-selezium">{t('footer.aboutUs') || 'Про нас'}</Link>
                    </div>
                    <div className="footer-links-group">
                        <Link to="/public-offer-agreement">{t('footer.contractOffer') || 'Договірна пропозиція'}</Link>
                        <Link to="/privacy-policy">{t('footer.privacyPolicy') || 'Політика конфіденційності'}</Link>
                        <a href="#refund-policy">{t('footer.refundPolicy') || 'Політика повернення'}</a>
                        <a href="#shipping-policy">{t('footer.shippingPolicy') || 'Політика доставки'}</a>
                        <a href="#accessibility">{t('footer.accessibility') || 'Заява про доступність'}</a>
                        <a href="#rules">{t('footer.rulesConditions') || 'Правила та умови користування сайтом'}</a>
                    </div>
                    <div className="footer-links-group">
                        <p>{t('footer.instagram') || 'Instagram'}</p>
                        <p>{t('footer.tiktok') || 'TikTok'}</p>
                        <p>{t('footer.youtube') || 'footer.youtube'}</p>
                    </div>
                </div>

                {/* Контакти нижче під посиланнями */}
                <div className="footer-contact">
                    <h3>{t('footer.contactTitle') || 'Контакти'}</h3>
                    <p>{t('footer.contactEmail') || 'selezium.com@gmail.com '}</p>
                    <p>{t('footer.contactPhone') || 'Тел: +380-73-069-5700'}</p>
                    <p>{t('footer.contactAddress1') || 'Lviv, Ukraine'}</p>
                    <p>{t('footer.contactTime') || 'Monday-Friday 9:00 am - 7:00 pm'}</p>
                </div>
            </div>
        </footer>
    );
}
